/**
 * «Enviar» + «Compartir con mi equipo» listos para poner en cualquier pantalla (docs/29 F3/F4).
 * Solo aparecen si Mensajes está disponible en el hub (`useMensajes().disponible`).
 */
import { useState } from 'react';
import { Button } from '@fluentui/react-components';
import { PeopleTeam16Regular, Send16Regular } from '@fluentui/react-icons';
import type { AppOrigen } from '../../api/mensajes.js';
import { useMensajes } from '../../lib/mensajesDisponibles.js';
import { CompartirConEquipoDialog } from './CompartirConEquipoDialog.js';
import { EnviarDialog, type AdjuntoParaEnviar } from './EnviarDialog.js';

export interface BotonesMensajesProps {
  app: AppOrigen;
  /** Id del documento (presupuesto, export…) para la bitácora y el aviso al equipo. */
  refDoc?: string;
  /** Nombre del documento (asunto, título del enlace y del aviso al equipo). */
  titulo: string;
  /** Enlace al documento (para el equipo; y para terceros si no hay adjunto). */
  url: string;
  asunto?: string;
  mensaje?: string;
  cargarAdjunto?: () => Promise<AdjuntoParaEnviar | null>;
  /** Mostrar «Compartir con mi equipo» (por omisión, sí). */
  equipo?: boolean;
  size?: 'small' | 'medium';
  appearance?: 'secondary' | 'subtle' | 'outline';
  /** Solo íconos (en tablas). */
  soloIconos?: boolean;
}

export function BotonesMensajes(p: BotonesMensajesProps): JSX.Element | null {
  const { disponible } = useMensajes();
  const [enviar, setEnviar] = useState(false);
  const [equipo, setEquipo] = useState(false);
  if (!disponible) return null;
  const size = p.size ?? 'small';
  const appearance = p.appearance ?? 'secondary';
  return (
    <>
      <Button
        size={size}
        appearance={appearance}
        icon={<Send16Regular />}
        title="Enviar desde mi correo o por WhatsApp"
        aria-label={p.soloIconos ? 'Enviar' : undefined}
        onClick={() => setEnviar(true)}
      >
        {p.soloIconos ? undefined : 'Enviar'}
      </Button>
      {p.equipo !== false && (
        <Button
          size={size}
          appearance={appearance}
          icon={<PeopleTeam16Regular />}
          title="Compartir con mi equipo"
          aria-label={p.soloIconos ? 'Compartir con mi equipo' : undefined}
          onClick={() => setEquipo(true)}
        >
          {p.soloIconos ? undefined : 'Compartir con mi equipo'}
        </Button>
      )}
      <EnviarDialog
        abierto={enviar}
        onCerrar={() => setEnviar(false)}
        titulo={`Enviar · ${p.titulo}`}
        origen={{ app: p.app, ...(p.refDoc ? { ref: p.refDoc } : {}) }}
        asunto={p.asunto ?? p.titulo}
        mensaje={p.mensaje ?? ''}
        enlace={p.cargarAdjunto ? null : { url: p.url, titulo: p.titulo }}
        cargarAdjunto={p.cargarAdjunto}
      />
      {p.equipo !== false && (
        <CompartirConEquipoDialog
          abierto={equipo}
          onCerrar={() => setEquipo(false)}
          titulo={p.titulo}
          url={p.url}
          app={p.app}
          refDoc={p.refDoc}
        />
      )}
    </>
  );
}
